import { HttpParams } from '@angular/common/http';
import { PaginationParams } from '../types';

export class PaginationParamsDto {
    readonly params: HttpParams;

    constructor(value: PaginationParams) {
        let params = new HttpParams().set('page', value.page).set('limit', value.limit);

        if (value.sort) {
            params = params.set('sort', value.sort);
        }
        if (value.order) {
            params = params.set('order', value.order);
        }
        if (value.search) {
            params = params.set('search', value.search);
        }
        if (value.assigned) {
            params = params.set('assigned', value.assigned);
        }

        this.params = params;
    }
}
